import { useState } from "react"
import { List } from "@mui/material"
import { DialogBox } from "lib/@components/dialogBox"
import { Repeat } from "lib/@components/repeat"
import { Bound } from "lib/@components/binding/Bound"
import { MoveToPositionListItem } from "./move-to-position-list-item"

export function MoveToPositionDialog({ tasks, currentTask }) {
    const [selectedTask, setSelectedTask] = useState(null)
    const caption = selectedTask ? `Move to position ${selectedTask?.$index}` : "Move"

    return (
        <DialogBox title="Move to position" value={selectedTask} okCaption={caption} okIcon="mdi:arrow-right">
            <List dense disablePadding sx={{ maxHeight: 420, overflowY: "auto", mt: 1 }}>
                <Bound onSelect={setSelectedTask} currentTask={currentTask} selectedTask={selectedTask}>
                    <Repeat list={tasks} item={<MoveToPositionListItem />} />
                </Bound>
            </List>
        </DialogBox>
    )
}
